const DEV_CRM_API_URL = "http://localhost:8082";

function normalizeBaseUrl(url) {
	return (url || "").replace(/\/$/, "");
}

export function getCrmApiBaseUrl() {
	const configuredUrl = normalizeBaseUrl(
		process.env.REACT_APP_CRM_API_URL || process.env.REACT_APP_API_URL || ""
	);
	if (configuredUrl) {
		return configuredUrl;
	}

	if (process.env.NODE_ENV === "development") {
		return DEV_CRM_API_URL;
	}

	return "";
}

export function crmApiFetch(path, options = {}) {
	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	const defaultOptions = {
		credentials: "include",
	};

	return fetch(`${getCrmApiBaseUrl()}${normalizedPath}`, {
		...defaultOptions,
		...options,
	});
}
